export default {
    items: {
        data: null
    },
    active: {
        data: null
    },
    id: ''
}